import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { CategoryRating } from '@/domain/entities/dashboard/categoryRating'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { CategoryRatingModuleName } from '@/store/modules/modules'

export class CategoryRatingViewModel {
  private store = useStore()

  userWhatCategoryRatingList: ComputedRef<CategoryRating[][]> = computed(
    () => this.store.getters[`${CategoryRatingModuleName}/userWhatCategoryRatingList`]
  )
  userHowCategoryRatingList: ComputedRef<CategoryRating[][]> = computed(
    () => this.store.getters[`${CategoryRatingModuleName}/userHowCategoryRatingList`]
  )
  userProgrammingCategoryRatingList: ComputedRef<CategoryRating[][]> = computed(
    () => this.store.getters[`${CategoryRatingModuleName}/userProgrammingCategoryRatingList`]
  )
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${CategoryRatingModuleName}/isLoading`])
  error: ComputedRef<string | null> = computed(() => this.store.getters[`${CategoryRatingModuleName}/error`])

  async addUserCategoryRating(userId: string): Promise<void> {
    await this.store.dispatch(`${CategoryRatingModuleName}/addUserCategoryRating`, { userId: userId })
  }

  async addUserCategoryRatingByLanguage(userId: string, programLanguage: ProgramLanguageType | 'All'): Promise<void> {
    await this.store.dispatch(`${CategoryRatingModuleName}/addUserCategoryRatingByLanguage`, {
      userId: userId,
      programLanguage: programLanguage
    })
  }

  removeUserCategories(): void {
    this.store.commit(`${CategoryRatingModuleName}/removeUserCategories`)
  }

  removeTargetUsers(): void {
    this.store.commit(`${CategoryRatingModuleName}/removeTargetUsers`)
  }
}
